<script>
	import Router from "svelte-spa-router";
	import { wrap } from "svelte-spa-router/wrap";

	import WebixTable from "./WebixTable.svelte";
	import PurchasePreview from "./PurchasePreview.svelte";
	import PurchaseCustom from "./PurchaseCustom.svelte";

	const routes = {
		"/": wrap({
			component: WebixTable,
			props: { product: "core" },
		}),
		"/preview-pack/custom": wrap({
			component: PurchaseCustom,
		}),
		"/preview-pack/:name": wrap({
			component: PurchasePreview,
			conditions: detail => {
				return detail.params !== "custom";
			},
		}),
	};
</script>

<div class="message">
	<b>
		All plans come with a &nbsp;
		<a href="/legalnote/developer-license-agreement/">
			perpetual commercial license
		</a>
		&nbsp; and one year of updates and support.
	</b>
	<p>
		We are here to help. If you need assistance with your purchase, please
		<a href="mailto:ekaterina@webix.com">email</a>
		.
	</p>
</div>

<Router {routes} />

<style>
	.message {
		font-size: 1.6rem;
		line-height: 2.5rem;
		font-weight: 400;
		color: rgba(0, 0, 0, 0.7);
		max-width: max-content;
		margin: 0rem auto 2.5rem auto;
	}
</style>
